import React from 'react';
import { Icon, IconProps } from './Icon';

export const ChevronRightIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 8 12" {...props}>
      <path
        d="M1.5 11L6.23782 6.58926C6.58739 6.26382 6.58739 5.73618 6.23782 5.41074L1.5 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};
